<template>
  <div class="card-ticket-new">
    <!-- <div class="card-ticketLeft"> -->
    <div class="card-ticket-left">
      <!-- <img src=""
           alt=""> -->
      <div class="card-ticket-bg">
        <img src="../../assets/images/card-ticket/du.png" alt="">
        <!--  -->
        <p class="card-ticket-tex card-ticket-title" :title="formInline.ticketName">{{formInline.ticketName}}</p>
        <p class="card-ticket-tex card-ticket-symk" ref="syms"></p>
        <p class="card-ticket-tex card-ticket-date" v-if="radio == 1"><span>{{formInline.startTimeStr}}</span> 至
          <span>{{formInline.endTimeStr}}</span> </p>
        <p class="card-ticket-tex card-ticket-date" v-if="radio == 0">领券当日起<span> {{formInline.receiveLimitDay}}
          </span>天内可用</p>
        <img src="../../assets/images/card-ticket/code.png" alt="" class="card-ticket-code">
        <div class="card-ticket-tex card-ticket-tips">
          <ul>
            <li>
              <p class="yhtitle">
                <i class="card-ticket-icon"></i>优惠内容
              </p>
              <p class="yhContent" ref="yhtitle">
                {{formInline.discountContent}}
              </p>
            </li>
            <li>
              <p class="yhtitle">
                <i class="card-ticket-icon"></i>使用说明
              </p>
              <p class="yhContent" ref="yhContent">
                {{formInline.useExplain}}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- </div> -->

    <div class="card-ticket-right setting-content">
      <p class="card-info">基本信息</p>
      <el-form :inline="true" :rules="rules" :model="formInline" label-width="95px" class="card-form" :disabled="true">
        <el-form-item label="卡券类型" prop="ticketType">
          <el-select clearable v-model="formInline.ticketType" placeholder="请选择卡券类型">
            <el-option v-for="(item,index) in cardTypeOptions" :key="index" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="卡券名称" prop="ticketName">
          <el-input placeholder="请输入卡券名称" clearable v-model="formInline.ticketName" show-word-limit maxlength="30"
            :disabled="true">
          </el-input>
          <span class="cardNameYz">{{ticketName}}/20</span>
        </el-form-item>
        <el-form-item label="有效期" prop="isPeriodValidity">
          <div class="timeBox">
            <el-radio-group v-model="radio">
              <!--  -->
              <div class="card-trcekt-date">
                <el-radio :label="1">

                  <el-date-picker v-model="formInline.startTimeStr" type="datetime" placeholder="开始时间"
                    value-format="yyyy-MM-dd HH:mm">
                  </el-date-picker>
                  至
                  <el-date-picker v-model="formInline.endTimeStr" type="datetime" placeholder="结束时间"
                    value-format="yyyy-MM-dd HH:mm">
                  </el-date-picker>

                </el-radio>
              </div>
              <div class="card-trcekt-yxq">
                <el-radio :label="0">
                  领券当日起
                  <el-input v-model="formInline.receiveLimitDay" :max="999">
                  </el-input>
                  天内可用
                </el-radio>
              </div>
              <div class="card-trcekt-yxq">
                <el-radio :label="2">
                  长期有效
                </el-radio>
              </div>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="优惠内容" prop="discountContent" v-if="formInline.ticketType == 1">
          <el-input type="textarea" placeholder="200字以内，建议写明卡券对应的服务内容" v-model="formInline.discountContent"
            :autosize="{ minRows: 3, maxRows: 6 }" maxlength="200" @input="descInput('conent')">
          </el-input>
          <span class="textareaYz">{{discountContent}}/200</span>
        </el-form-item>
        <el-form-item label="可兑换产品范围" prop="productId" style="border:none;text-align:left;width: 100%;"
          v-if="formInline.ticketType !== 2">
          <div id="" style="max-height: 90px; overflow-y:auto ;">
            <el-select filterable remote :remote-method="remoteProductMethod" @click.native="getMyProductOptions"
              v-model="productId" multiple placeholder="请选择可兑换的产品">
              <el-option v-for="item in productRelationArray" :key="item.productCode" :label="item.productName"
                :value="item.productCode">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="代金券类型" prop="productId" v-if="formInline.ticketType == 3">
          <el-radio-group v-model="formInline.cashCouponType">
            <el-radio :label="1">随机金额代金券</el-radio>
            <el-radio :label="2">满减券</el-radio>
            <el-radio :label="3">折扣券</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="优惠内容" prop="discount" v-if="formInline.cashCouponType !== 1">
          <div class="faceValue-box">
            <span v-if="formInline.cashCouponType == 2">面值</span>
            <span v-else>打</span>
            <el-input v-model="formInline.discount">
            </el-input>
            <span v-if="formInline.cashCouponType == 2">元</span>
            <span v-else>折</span>
          </div>
        </el-form-item>
        <el-form-item label="使用门槛" prop="threshold"
          v-if="formInline.cashCouponType == 2 || formInline.cashCouponType == 3">
          <div class="timeBox faceValue-box">
            <el-radio-group v-model="formInline.threshold">
              <el-radio :label="1">无使用门槛</el-radio>
              <el-radio :label="2">
                <span>满</span>
                <el-input v-model="formInline.usingThreshold"></el-input>
                <span>元使用</span>
              </el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="优惠内容" prop="discountStart"
          v-if="formInline.ticketType == 3 && formInline.cashCouponType == 1">
          <div class=" cashCoupon_style">
            <el-col :span="5">
              <span>范围内随机</span>
            </el-col>
            <el-col :span="6">
              <el-input type="text" v-model="discountStart">
              </el-input>
            </el-col>
            <el-col :span="2">
              <div style="text-align: center;">至</div>
            </el-col>
            <el-col :span="6">
              <el-input type="text" v-model="discountEnd">
              </el-input>
            </el-col>
            <el-col :span="2">
              <div style="text-align: center;">元</div>
            </el-col>
            <el-col :span="2">
              <i class="el-icon-question" @mouseenter="enter()" @mouseleave="leave()"></i>
            </el-col>
            <div class="cashCoupon_ts" id="cashCoupon_ts">前后金额一致则为固定金额</div>
          </div>
        </el-form-item>
        <!-- <el-form-item label="核销操作"
                      prop="">
          <div class="card-hxSelect"
               v-for="(item, index) in hxList"
               :key="index">
            <el-select v-model="item.activityType"
                       placeholder="请选择受众"
                       :disabled="true">
              <el-option v-for="item in szOptions"
                         :key="item.modelId"
                         :label="item.modelName"
                         :value="item.modelId">
              </el-option>
            </el-select>
            <el-select v-model="item.qzType"
                       placeholder="请选择群组"
                       :disabled="true">
              <el-option v-for="items in qzOptions"
                         :key="items.groupId"
                         :label="items.groupName"
                         :value="items.groupId">
              </el-option>
            </el-select>
          </div>
        </el-form-item> -->
        <el-form-item label="核销操作" prop="">
          <el-select v-model="formInline.relateAudienceObject.modelId" placeholder="请选择受众">
            <el-option v-for="item in szOptions" :key="item.modelId" :label="item.modelName" :value="item.modelId">
            </el-option>
          </el-select>
          <div style="max-height: 90px; overflow-y:auto ;margin-top:15px;">
            <!-- @click.native="szChange"  :remote-method=""-->
            <el-select filterable remote multiple v-model="qzValue" placeholder="请选择群组">
              <el-option v-for="items in qzOptions" :key="items.groupId" :label="items.groupName"
                :value="items.groupId">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="使用说明" prop="useExplain">
          <el-input type="textarea" placeholder="200字以内" v-model="formInline.useExplain" show-word-limit maxlength="30">
          </el-input>
          <span class="textareaYz">{{remnant}}/500</span>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { cardList, getModelList, getModelGroupList, getProductList } from '@/api/cardTicket.js'
export default {
  data () {
    return {
      dataList: {
        'ticketName': '',
        'id': '',
        'page': {
          'limit': 10,//每页显示的条数
          'page': 1,//当前页数
        }
      },
      formInline: {
        id: '',
        ticketType: '',
        ticketName: '',
        isPeriodValidity: '',
        startTimeStr: '',
        endTimeStr: '',
        receiveLimitDay: '',
        discountContent: '',
        useExplain: '',
        relateAudienceObject: {
          modelId: '',
          groupIds: []
        },
        commoditys: [{
          code: '',
          name: ''
        }],
        cashCouponType: 1,//代金券类型
        faceValue: '',//面值
        threshold: 1,//使用门槛
        discount: 0,//打折数
        usingThreshold: ''
      },
      productId: '',
      productRelationArray: [],
      clickRelationArray: [],
      activityTypeOptions: {},
      cardType: '',
      cardTypeOptions: [
        {
          value: 1,
          name: '实物兑换券'
        },
        {
          value: 2,
          name: '活动券'
        },
        {
          value: 3,
          name: '代金券'
        },
      ],
      szNames: '',
      szOptions: [],//受众列表
      qzValue: '',
      qzOptions: [],//群组列表
      qzParams: {
        modelId: '',
        groupId: ''
      },
      rules: {
        ticketType: [{
          required: true,
          message: '请选择卡券类型',
          trigger: 'blur'
        }],
        ticketName: [{
          required: true,
          message: '请输入卡券名称',
          trigger: 'blur'
        }],
        isPeriodValidity: [{
          required: true,
          message: '请设定有效期',
          trigger: 'blur'
        }],
        discountContent: [{
          required: true,
          message: '请输入优惠内容',
          trigger: 'blur'
        }],
        useExplain: [{
          required: true,
          message: '请输入使用说明',
          trigger: 'blur'
        }],

      },
      formdiscountContent: '',
      ticketName: '',
      discountContent: 0,
      remnant: 0,
      validityDate: '',
      radio: 1,
      input: '',
      analyseQuotaData: [
        {
          analyseQuota: ['customer', 'peopleNum', 'sum']
        }
      ],
      hxList: [{
        activityType: '',
        qzType: ''
      }],
      commoditys: [],
      qzarr: [],
    }
  },
  methods: {
    leave () {
      document.getElementById('cashCoupon_ts').style.display = 'none'
    },
    enter () {
      document.getElementById('cashCoupon_ts').style.display = 'block'
    },
    //搜索时查询产品名称
    remoteProductMethod (query) {
      if (query !== '') {
        let data = {
          page: 1,
          limit: 10,
          value: query,
          activityId: ''
        }
        getProductList(data).then(res => {
          if (res.data.code == '200') {
            let result = res.data.result.list
            this.productRelationArray = result
            for (let i = 0; i < result.length; i++) {
              this.clickRelationArray.push(result[i])
            }
          }
        })
      } else {
        //					this.productRelationArray = []
      }
    },
    //点击时查询产品名称
    getMyProductOptions () {
      let data = {
        page: 1,
        limit: 10,
        value: '',
        activityId: ''
      }
      getProductList(data).then(res => {
        if (res.data.code == '200') {
          let result = res.data.result.list
          this.productRelationArray = result
          for (let i = 0; i < result.length; i++) {
            this.clickRelationArray.push(result[i])
          }
        }
      })
    },
    //模板详情
    getData () {
      this.dataList.id = this.$route.query.id
      cardList(this.dataList).then(res => {
        let result = res.data.result.list
        // 兑换的产品
        this.formInline.commoditys = result[0].commodity
        result[0].commodity = JSON.parse(result[0].commodity)
        if (result[0].commodity !== null) {
          for (let i of result[0].commodity) {
            this.commoditys.push(i.name)
          }
          this.productId = this.commoditys
        }
        this.formInline.id = result[0].id
        // 判断卡券的类型,等于1的时候将使用说明的换行进行展示
        this.formInline.ticketType = result[0].ticketType
        if (this.formInline.ticketType == 1) {
          this.formInline.discountContent = result[0].discountContent
          this.$refs.yhtitle.innerHTML = result[0].discountContent.replace(/\n/g, '<br>')
        } else if (this.formInline.ticketType == 3) {
          this.formInline.discountContent = result[0].discountContent
          this.$refs.yhtitle.innerHTML = result[0].discountContent
        }
        // 卡券名称
        this.formInline.ticketName = result[0].ticketName
        // 卡券名称效验
        this.ticketName = 20 - this.formInline.ticketName.length
        this.formInline.isPeriodValidity = result[0].isPeriodValidity
        // 判断有效期的形式
        if (this.formInline.isPeriodValidity == 1) {
          this.radio = 1
          let str = result[0].startTimeStr + ',' + result[0].endTimeStr
          this.validityDate = str.split(',')
          this.formInline.startTimeStr = this.validityDate[0].slice(0, 16)
          this.formInline.endTimeStr = this.validityDate[1].slice(0, 16)
        } else if (this.formInline.isPeriodValidity == 0) {
          this.radio = 0
          this.formInline.receiveLimitDay = result[0].receiveLimitDay
          this.formInline.startTimeStr = ''
          this.formInline.endTimeStr = ''
        } else {
          this.radio = 2
          this.formInline.startTimeStr = ''
          this.formInline.endTimeStr = ''
          this.formInline.receiveLimitDay = ''
        }
        // 优惠内容
        this.formdiscountContent = result[0].discountContent
        if (result[0].discountEnd === '' || result[0].discountStart === 0) {
          this.discountStart = ''
          this.discountEnd = ''
        } else {
          this.discountStart = result[0].discountStart
          this.discountEnd = result[0].discountEnd
        }
        this.formInline.cashCouponType = result[0].cashCouponType
        this.formInline.discount = result[0].discount
        if (result[0].usingThreshold != '' && result[0].usingThreshold != null) {
          this.formInline.usingThreshold = result[0].usingThreshold.toString()
          this.formInline.threshold = 2
          this.$refs.syms.innerHTML = '满' + this.formInline.usingThreshold + '元使用'
        } else {
          this.$refs.syms.innerHTML = '无使用门槛'
        }
        // 优惠内容字数校验
        this.discountContent = 200 - this.formdiscountContent.length
        // 将优惠内容中的换行进行显示
        this.$refs.yhContent.innerHTML = result[0].useExplain.replace(/\n/g, '<br>')
        this.formInline.useExplain = result[0].useExplain
        // 使用说明的字数效验
        this.formInlineuseExplain = result[0].useExplain
        this.remnant = 500 - this.formInlineuseExplain.length
        // 核销操作的受众群组
        // 核销操作的受众群组
        result[0].relateAudience = JSON.parse(result[0].relateAudience)
        this.formInline.relateAudienceObject.modelId = result[0].relateAudience.modelId
        if (result[0].relateAudience.groupIds !== undefined) {
          this.qzValue = result[0].relateAudience.groupIds
          this.qzParams.groupIds = result[0].relateAudience.groupIds
        }
        this.getQZList()
      })
    },
    dateTimeChange () {
      if (this.validityDate != undefined || this.validityDate != '') {
        this.formInline.startTimeStr = this.validityDate[0]
        this.formInline.endTimeStr = this.validityDate[1]
      }
    },
    getSzList () {
      getModelList().then(res => {
        this.szOptions = res.data.result
      })
    },
    getQZList () {
      getModelGroupList(this.qzParams).then(res => {
        this.qzOptions = res.data.result
      })
    },
  },
  mounted () {
    //获取受众列表
    this.getSzList()
    this.getData()
    this.getMyProductOptions()

  }
}
</script>

<style scoped>
</style>
